import { type ReprocessingInvoiceStatus } from '~/data/invoice-reprocessing';

// fallow-ignore-next-line complexity
export const getStatusColorClass = (status: ReprocessingInvoiceStatus) => {
  switch (status) {
    // Severity: FIX!
    case 'ai_data_error':
    case 'ai_parsing_error':
    case 'ambiguous_ai_files_error':
    case 'ambiguous_files_error':
    case 'company_matching_error':
    case 'failed_to_attach_mail_to_process_error':
    case 'failed_to_send_mail_error':
    case 'handoff_failed':
    case 'invalid_attachments_error':
    case 'invalid_azure_response_error':
    case 'invoice_data_error':
    case 'invoice_process_stopper_error':
    case 'no_ai_model_settings_error':
    case 'no_parser_found_error':
    case 'unauthorized_sender_error':
    case 'unknown_error':
    case 'unknown_receiver_error': {
      return 'bg-tiga-surface-darkest text-white';
    }

    // Severity: OK
    case 'directly_forwarded':
    case 'done':
    case 'handed_off':
    case 'manually_dismissed': {
      return 'bg-tiga-surface-lighter text-tiga-text-lighter';
    }

    // Severity: WATCH
    case 'delayed':
    case 'in_process':
    case 'waiting_for_add_email':
    case 'waiting_for_ai_parsing':
    case 'waiting_for_attaching_mail_to_process':
    case 'waiting_for_invoice_service_handoff':
    case 'waiting_for_parsing':
    case 'waiting_for_sending':
    default: {
      return 'bg-tiga-surface-default text-tiga-text-default';
    }
  }
};
